import "./about.css";
import React from "react";
import photo1 from "../Assets/point.jpg"
import photo2 from "../Assets/balls.jpg"


export default function About(props) {
  return (
    <div className={props.size === "sm" ? "about-container sm" : "about-container"} id="About">
        <img src={photo1} alt="photo" />
        <div className="buttonFormat">
        <button className="FormButton"> <a href="https://aausports.org" target="blank"> AAU Info </a> </button>
        <button className="FormButton"> <a href="https://docs.google.com/document/d/1GPO4btItWiLqf81pjusdje7SmWxB1adX/edit?usp=sharing&ouid=105499710533681496050&rtpof=true&sd=true" target="blank"> Handbook </a> </button>
        </div>
        <img src={photo2} alt="photo" />
    </div>
  );
}
